import { useEffect, useState } from "react";
import { Table } from "antd";

import { api } from "../api/client";
import { PageHeader } from "../components/PageHeader";
import { formatDateTimeIST } from "../utils/format";

interface AuditRow {
  id: string;
  user_email: string | null;
  action: string;
  entity_type: string;
  entity_id: string | null;
  ip_address: string | null;
  created_at: string;
}

export function AuditLogPage() {
  const [rows, setRows] = useState<AuditRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    setLoading(true);
    api
      .get("/audit-logs/", { params: { page, page_size: 50 } })
      .then((r) => {
        setRows(r.data.results);
        setTotal(r.data.count);
      })
      .finally(() => setLoading(false));
  }, [page]);

  return (
    <div className="page-shell">
      <PageHeader title="Audit Log" subtitle="Every state-changing action by every user." />
      <Table
        rowKey="id"
        loading={loading}
        dataSource={rows}
        pagination={{ current: page, pageSize: 50, total, onChange: setPage }}
        columns={[
          {
            title: "When",
            dataIndex: "created_at",
            render: (v: string) => formatDateTimeIST(v),
          },
          { title: "User", dataIndex: "user_email" },
          { title: "Action", dataIndex: "action", render: (v: string) => <span className="mono">{v}</span> },
          { title: "Entity", dataIndex: "entity_type" },
          { title: "Entity ID", dataIndex: "entity_id", render: (v: string) => <span className="mono" style={{ fontSize: 11 }}>{v || "—"}</span> },
          { title: "IP", dataIndex: "ip_address", render: (v: string) => <span className="mono">{v || "—"}</span> },
        ]}
      />
    </div>
  );
}
